// extracted by mini-css-extract-plugin
module.exports = {"cvContainer":"cv-module--cvContainer--HFjhq","cvHeader":"cv-module--cvHeader--1hiAu","bold":"cv-module--bold--3lNFp"};